import EsSummaryView, {type EsSummaryViewProps} from '@/pages/components/audit-program/e-section/EsSummaryView';
import {FS_PAGE, type FSummaryPage} from '@/pages/components/audit-program/f-section/constants';

export type FsSummaryViewProps = Omit<EsSummaryViewProps, 'page' | 'fallback' | 'refCode'> & {
    page: FSummaryPage;
    refCode?: string;
};

/** Fs — Summary sheet for PPE objectives (same layout as Es). */
export default function FsSummaryView({
    page,
    refCode = 'Fs',
    ...rest
}: FsSummaryViewProps) {
    return <EsSummaryView {...rest} page={page} fallback={FS_PAGE} refCode={refCode}/>;
}
